import { type FieldValues } from "@/pages/OpenBriefPage/BriefSummary/BriefSummary.types";

export enum FieldValueSource {
  USER = "USER",
  ASSISTANT = "ASSISTANT",
}

export type SendMessagePayload = {
  content: string;
  conversationId?: string;
  fieldValues?: FieldValues;
  lang?: string;
};

export type ConversationStartedResponse = {
  conversationId: string;
  status: "processing";
};

export type ConversationReadyResponse = {
  conversationId: string;
  status: "ready";
  data: {
    conversationId: string;
    message: {
      content: string;
      role: "assistant";
    };
    fieldValues: FieldValues;
    productAdmaId?: string;
    productName?: string;
    deliverableAdmaId?: string;
    versionsCount?: number;
    quantity?: number;
  };
  timestamp: string;
};

export type ConversationErrorResponse = {
  conversationId: string;
  status: "error";
  error?: string;
  timestamp: string;
};

export type AIChatMessage = {
  id: number;
  message: string;
  sentByUser: boolean;
};
